import { PRODUCT_CATEGORIES } from 'search/enums/constants';
import { ParsedUrlQuery } from 'querystring';

import { ITransformedCategory } from 'search/types/Category';
import { IConstructorFacetMultiple } from 'shared/types/ConstructorFacet';

import { getCategoryFilterQuery } from './getCategoryFiltersQuery';

interface ICrawlerCategoryFiltersLinkHref {
  pathname: string;
  query: ParsedUrlQuery;
  category: ITransformedCategory;
  facet: IConstructorFacetMultiple | ITransformedCategory;
}

// Util function to create interlinks for bots to crawl and index
export const getCrawlerCategoryFiltersLinkHref = ({
  pathname,
  query,
  category,
  facet,
}: ICrawlerCategoryFiltersLinkHref) => {
  // brand/[slug] => ex. /brand/air-jordan
  // links to /sneakers/brand/air-jordan or /apparel/brand/air-jordan
  if (pathname.includes('brand') && query?.slug) {
    return `/${category.value}/brand/${query.slug as string}`;
  }

  // [pageSlug]/brand/[brandName] => ex. /sneakers/brand/air-jordan
  if (query?.pageSlug && Object.keys(query).length > 1) {
    if (query?.brandName) {
      // links to /sneakers/brand/air-jordan/basketball
      return `/${query.pageSlug as string}/brand/${query.brandName as string}/${category.value}`;
    }
    // ex. /sneakers/silhouette/air-jordan-1 or sneakers/color/black
    if (query?.silhouette || query?.colorValue) {
      // links to /sneakers/basketball
      return `/${query.pageSlug as string}/${category.value}`;
    }
  }

  const pathnameOrigin = pathname.split('/')[1];
  if (pathnameOrigin && PRODUCT_CATEGORIES.includes(pathnameOrigin)) {
    // links to /sneakers/basketball or /apparel/tops
    return `/${pathnameOrigin}/${category.value}`;
  }

  return { pathname, query: getCategoryFilterQuery(query, category, facet) };
};
